import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5b686822&lang=sass&scoped=true"

import exportComponent from "/Users/yablonev/Desktop/Yablonev/Coding/GitHub/TON/Highload-UI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b686822"]])

export default __exports__